module.exports = __webpack_public_path__ + "static/img/mix-data.4fed3437.svg";